// first things first: check for updates

import { registerSW } from 'virtual:pwa-register'
registerSW({ immediate: true })


// const intervalMS = 5 * 60 * 1000 // every 5 minutes
// const updateSW = registerSW({
//   onRegistered(r) {
//     r && setInterval(() => {
//       r.update()
//     }, intervalMS)
//   }
// })


// the rest
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import account, { track } from '@/controllers/account';

import("@sentry/react").then(Sentry =>
  Sentry.init({
    dsn: "https://22d5b4b45fba41feb6a764909dce9627@o4509931738300416.ingest.us.sentry.io/4509931744133120",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.feedbackIntegration({
        colorScheme: "system",
        autoInject: false
      }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^.*soclearn.org/, /^\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
);

import('@microsoft/clarity').then(Clarity => Clarity.default.init("t52wwz56er"))

account.init();
import('@/controllers/Live2D').then(Live2D => Live2D.init())
import('@/controllers/Jupyter').then(Jupyter => Jupyter.init())

track();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);